type ServiceAgreementAttribute = { value?: string };
type ServiceAgreementWithAttributes = { attributes?: ServiceAgreementAttribute[] };

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const parseServiceAgreementAttributes = (
  serviceAgreement: ServiceAgreementWithAttributes | ServiceAgreementAttribute[] | null | undefined,
): Record<string, unknown>[] => {
  const attributes = Array.isArray(serviceAgreement) ? serviceAgreement : serviceAgreement?.attributes;
  const value = attributes?.[0]?.value;
  if (!value) {
    return [];
  }
  const parsed: unknown = JSON.parse(value);
  return Array.isArray(parsed) ? parsed.filter(isRecord) : [];
};
